import { FormControl, FormGroup, Validators } from '@angular/forms';
import { RegionId } from './region-id.enum';
import { TreatmentTypeOriginalId } from './treatmentType';
import { FabricationMethod } from './fabrication-method';
import { LocaleCodes } from '../constants';

export const createTreatmentMessageTemplateForm = (treatmentTypeId: TreatmentTypeOriginalId) =>
    new FormGroup({
        region: new FormControl<RegionId | null>(null, {
            validators: [Validators.required],
        }),
        message: new FormControl<string>('', {
            validators: [Validators.required],
        }),
        hasTreatmentPlan: new FormControl<boolean | null>(null, {
            validators: [],
        }),
        treatmentTypeId: new FormControl<TreatmentTypeOriginalId | null>(null, {
            validators: [Validators.required],
        }),
        organizationId: new FormControl<string | null>(null, {
            validators: [],
        }),
        revisionMessage: new FormControl<string | null>(null, {
            validators: [],
        }),
        isDefault: new FormControl(false, {
            validators: [Validators.required],
        }),
        fabricationMethod: new FormControl<FabricationMethod | null>(null, {
            validators: [],
        }),
        locale: new FormControl<string | null>(null, {
            validators: [Validators.required],
        }),
        isFirstOrSecondOrderOnly: new FormControl<boolean | null>(null, {
            validators: [],
        }),
        id: new FormControl<number | null>(0, { nonNullable: false }),
    });

export type TreatmentMessageTemplateEditForm = ReturnType<typeof createTreatmentMessageTemplateForm>;
export type TreatmentMessageTemplateEditModel = TreatmentMessageTemplateEditForm['value'];

export const DefaultTreatmentMessageTemplateEditModel: TreatmentMessageTemplateEditModel = Object.freeze({
    region: RegionId.northAmerica,
    message: '',
    hasTreatmentPlan: null,
    treatmentTypeId: TreatmentTypeOriginalId.NotSelected,
    organizationId: null,
    revisionMessage: null,
    isDefault: false,
    fabricationMethod: null,
    locale: LocaleCodes.enUS,
    isFirstOrSecondOrderOnly: null,
    id: 0,
});
